"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.2,25c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8s6.8,3,6.8,6.8S22,25,18.2,25z M18.2,12.5c-3.2,0-5.8,2.6-5.8,5.8 c0,3.2,2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8C24,15.1,21.4,12.5,18.2,12.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,18.7h-2.1c-0.3,0-0.5-0.2-0.5-0.5v-3.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.2h1.6c0.3,0,0.5,0.2,0.5,0.5 S20.6,18.7,20.3,18.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.2,25c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8s6.8,3,6.8,6.8S22,25,18.2,25z M18.2,12.5c-3.2,0-5.8,2.6-5.8,5.8 c0,3.2,2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8C24,15.1,21.4,12.5,18.2,12.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,18.7h-2.1c-0.3,0-0.5-0.2-0.5-0.5v-3.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.2h1.6c0.3,0,0.5,0.2,0.5,0.5 S20.6,18.7,20.3,18.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5,22.9h-11c-0.3,0-0.5-0.2-0.5-0.5V0.5C0,0.2,0.2,0,0.5,0H12c0.1,0,0.3,0.1,0.4,0.1l5.2,5.2c0.1,0.1,0.1,0.2,0.1,0.4 v4.7h-1V5.9L11.8,1H1v20.9h10.5V22.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.2,6.2H12c-0.3,0-0.5-0.2-0.5-0.5V0.5C11.5,0.2,11.7,0,12,0s0.5,0.2,0.5,0.5v4.7h4.7c0.3,0,0.5,0.2,0.5,0.5 S17.5,6.2,17.2,6.2z"
  }));
};

exports["default"] = _default;